module.exports = __webpack_public_path__ + "static/media/Gridnew.4525f37d.svg";